import { withPublicWrapper } from '../components/public/Wrapper/withPublicWrapper';
import Intro from 'components/public/Intro/Intro';
import React from 'react';
import IntroBlock from 'components/public/Intro/IntroBlock';
import { Col, Divider } from 'antd';
import ContactForm from 'components/ContactForm';
import Head from 'next/head';

const CookiePolicy = (): JSX.Element => {
  return (
    <>
      <Head>
        <script
          dangerouslySetInnerHTML={{
            __html: `
            (function(d, s, id) {
                var js, tjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s); js.id = id;
                js.src = "https://app.termly.io/embed-policy.min.js";
                tjs.parentNode.insertBefore(js, tjs);
              }(document, 'script', 'termly-jssdk'));
          `,
          }}
        />
      </Head>
      <Intro
        title="Cookie Policy"
        image={{ src: '/logo.png', alt: 'logo', width: '1779', height: '1608' }}
        descriptionText="We do the hitching, you do the hiking"
      />
      <IntroBlock
        type="white"
        description={
          <Col>
            {/* <!-- Termly Tracking Code --> */}

            <div
              dangerouslySetInnerHTML={{
                __html: `
                <div name="termly-embed" data-id="5eb49fcf-0f37-447f-b97e-8386f069a5d6" data-type="iframe"></div>
            `,
              }}
            ></div>
            <Divider orientation="center">Want to know more? Contact us</Divider>
            <ContactForm withoutApps />
          </Col>
        }
      />
    </>
  );
};

export default withPublicWrapper(CookiePolicy);
